import * as React from 'react'
import Box from '@mui/material/Box'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import SmsIcon from '@mui/icons-material/Sms'
import AbcIcon from '@mui/icons-material/Abc'
import MessageIcon from '@mui/icons-material/Message'
import HubIcon from '@mui/icons-material/Hub'
import TaskIcon from '@mui/icons-material/Task'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'
import PostAddIcon from '@mui/icons-material/PostAdd'
import FilterDramaIcon from '@mui/icons-material/FilterDrama'
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun'
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt'
import TagIcon from '@mui/icons-material/Tag'
import ViewKanbanIcon from '@mui/icons-material/ViewKanban'
import ListAltIcon from '@mui/icons-material/ListAlt'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark'
import PermMediaIcon from '@mui/icons-material/PermMedia'

import { DialogContext } from '../context/DialogContext.js'

export default function AddButtonWork({ toggleViewKanban, toggleViewTaskBoard, toggleMediaView, toggleJournalView }) {
  const { dialogStates, openDialog, closeDialog } = React.useContext(DialogContext)

  const actions = [
    // { icon: <DirectionsRunIcon />, name: 'Action' },
    // { icon: <SelfImprovementIcon />, name: 'Self Improvement' },
    { icon: <PostAddIcon />, name: 'Project', onClick: () => openDialog('dialogAddProject') },
    { icon: <TaskIcon />, name: 'Task', onClick: () => openDialog('dialogAddTask') },
    { icon: <PostAddIcon />, name: 'Import Tasks (Doc)', onClick: () => openDialog('dialogAddTaskGroup') },
    { icon: <NoteAddIcon />, name: 'New Note', onClick: () => openDialog('dialogAddNote') },
    { icon: <CollectionsBookmarkIcon />, name: 'My Notes', onClick: () => openDialog('dialogNotesList') },
    { icon: <ViewKanbanIcon />, name: 'Kanban', onClick: () => toggleViewKanban() },
    { icon: <ListAltIcon />, name: 'Task Board', onClick: () => toggleViewTaskBoard() },
    // Moved here from the blue Views dial.
    { icon: <PermMediaIcon />, name: 'Media', onClick: () => toggleMediaView && toggleMediaView() },
    { icon: <SelfImprovementIcon />, name: 'Journal', onClick: () => toggleJournalView && toggleJournalView() }
  ]

  return (
    <SpeedDial ariaLabel="SpeedDialLife" icon={<HubIcon />}>
      {actions.map((action) => (
        <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
      ))}
    </SpeedDial>
  )
}
